var _circle, _path, _line, _circle2, _path2, _line2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 40,
    viewBox: "0 0 290 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00CADE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.33L17.33 24.66L26.0053 16",
    stroke: "white",
    strokeWidth: 2.29505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 19.5,
    x2: 113,
    y2: 19.5,
    stroke: "#00CADE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 20,
    r: 20,
    fill: "#00CADE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 20.33L142.33 24.66L151.005 16",
    stroke: "white",
    strokeWidth: 2.29505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: 177,
    y1: 19.5,
    x2: 238,
    y2: 19.5,
    stroke: "#00A1BA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#00CADE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 20,
    r: 8,
    fill: "#00CADE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify2);
export default __webpack_public_path__ + "static/media/verify2.64975097b8d7160784cbef6576572106.svg";
export { ForwardRef as ReactComponent };